const initialState = {
  applicant: {
    valid: false,
    data: {
      first_name: "",
      middle_name: "",
      last_name: "",
      dob: "",
      occupation: "",
      gender: "",
      married: "",
      sr_22: "",
      address: "",
      apt: "",
      city: "",
      state: "",
      county: "",
      zipcode: "",
      email: "",
      phone: "",
      term: 6,
      contract_start_date: "",
      rent_own: "OWNED",
      is_other_insurance: false,
      employer_zipcode: null,
      is_employer_zipcode: false,
      other_insurance: {
        company: "OTHER",
        terms: "",
      },
    },
  },
  vehicles: {
    valid: false,
    data: [],
    car: {
      car_vin: "",
      car_make: "",
      car_model: "",
      car_year: "",
      car_lease: "",
      use_type: "",
      coverages: {
        BI: "25000-50000",
        UM: "25000-50000",
        PD: "20000",
        MEDPM: "1000",
      },
    },
  },
  drivers: {
    driver_count: "",
    data: [],
    driver: {
      first_name: "",
      middle_name: "",
      last_name: "",
      dob: "",
      occupation: "",
      gender: "",
      married: "",
      sr_22: "",
      // auto_dvantage: "on",
      any_tickets: false,
      relation_with_holder: "",
      dl_state: null,
      dl_number: null,
      dl_exp: null,
      license_status: null,
      tickets: [],
    },
  },
  quote: {
    details: null,
    socket_id: null,
    isCompare: false,
    checkAmount: false,
    updateQuoteLoader: false,
    isSelectPlan: false,
    isQuestionRequest: false,
    payment_data: {
      basic: null,
      recommend: null,
    },
    basic: {
      response: null,
      payment_info: null,
      stripe_intent: null,
    },
    total_premium: "232",
    addons_amount: null,
    response: null,
    phone: "",
    isVerify: false,
    eSign: false,
    docuSign: {
      esign_url: "",
    },
    plan: null,
    payment_info: null,
    stripe_intent: null,
    payment_plan: "monthly",
    type: "basic",
    custom: false,
    answers: {
      answered: false,
      data: [],
    },
    getQuoteError: null,
  },
  contract: {},
  final: {},
  // buy: {},
  contract_payment: [],
  payment: {},
};

export default initialState;
